<!-- 払い戻し時、book_groupの情報更新に失敗した場合に表示するダイアログ -->
<template>
  <ItemDialog ref="bookRefundError" image-type="alert">
    <template #content-area>
      <p class="text-center">
        払い戻しの結果をチケットに反映できませんでした。お手数ですがサポートセンターにお問い合わせください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogBookRefundError",
  setup(props) {
    const bookRefundError = ref(null);

    const openDialog = () => {
      bookRefundError.value.open();
    };

    const closeDialog = () => {
      nativeHandlerService.returnNativeAppTopPage();
    };

    return {
      bookRefundError,
      openDialog,
      closeDialog,
    };
  },
};
</script>
